module.exports = __webpack_public_path__ + "img/tylernasty_thumb.42ed55ba.jpg";